import ProjectDeleteDialog from "@/components/project/project-delete-dialog";
import ProjectEnvironments from "@/components/project/project-environments";
import { ProjectImageUpload } from "@/components/project/project-image-upload";
import ProjectUpdateForm from "@/components/project/project-update-form";
import { trpc } from "@/lib/trpc";
import { Button } from "@papier/ui/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@papier/ui/components/ui/card";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Settings, Trash2, TriangleAlert } from "lucide-react";
import { useState } from "react";

export const Route = createFileRoute("/_app/projects/$projectSlug/_layout/settings")({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectSlug } = Route.useParams();
  const { data: project } = useSuspenseQuery(trpc.projects.getBySlug.queryOptions({ projectSlug }));
  const [isDelete, setIsDelete] = useState(false);

  return (
    <main className="grid gap-6">
      <section className="flex items-center justify-between">
        <div>
          <h1 className="text-foreground flex items-center gap-2 text-2xl font-bold">
            <Settings className="size-5" />
            Settings
          </h1>
          <p className="text-foreground/80">Manage your project settings</p>
        </div>
      </section>

      <ProjectImageUpload
        projectId={project.id}
        projectName={project.name}
        currentImage={project.image}
      />
      <ProjectUpdateForm projectSlug={projectSlug} />
      <ProjectEnvironments projectSlug={projectSlug} />
      <Card className="glass-card">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <TriangleAlert className="size-5" />
            Danger Zone
          </CardTitle>
          <CardDescription>
            The following actions are destructive and cannot be reversed.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="border-destructive/50 flex items-center justify-between rounded-lg border p-4">
            <div>
              <h4 className="text-foreground font-medium">Delete Project</h4>
              <p className="text-muted-foreground text-sm">
                Permanently delete this project and all its templates.
              </p>
            </div>
            <Button variant="destructive" onClick={() => setIsDelete(true)}>
              <Trash2 />
              Delete
            </Button>
          </div>
        </CardContent>
      </Card>

      <ProjectDeleteDialog
        open={!!isDelete}
        projectId={project.id}
        setOpen={(open) => {
          if (!open) setIsDelete(false);
        }}
      />
    </main>
  );
}
